export const INTERVAL_2M = 2 * 60 * 1000;
export const INITIAL_LOAD_TIMEOUT = 10 * 1000;
